import React, { PropsWithChildren } from 'react';
import { Box } from '@landr/maestro';
import { cva } from '@landr/styled-system/css';

type SliceSpacing = 'base' | 'minimal' | 'none';

const sliceStyles = cva({
    base: {
        position: 'relative',
        width: '100%',
    },
    variants: {
        spacing: {
            base: {
                paddingBottom: '4xl',
            },
            minimal: {
                paddingBottom: '2xl',
            },
            none: {
                paddingBottom: 0,
            },
        },
    },
    defaultVariants: {
        spacing: 'base',
    },
});

export const Slice: React.FC<PropsWithChildren<{ spacing?: SliceSpacing }>> = ({
    children,
    spacing = 'base',
}) => (
    <Box data-component="Slice" className={sliceStyles({ spacing })}>
        {children}
    </Box>
);
